import { ITabOption, TTranslator } from '@smartshell/ui-kit';

import { PermissionKey } from 'auth/types';
import { TLocalesKeys } from 'localization';

import { ETabs } from './interfaces';

const getTabs = (
  t: TTranslator<TLocalesKeys>,
  permissions: Set<PermissionKey> | null
): Array<ITabOption<ETabs>> => [
  {
    value: ETabs.WORKSHIFT,
    title: t('reports.tabs.workShifts'),
    iconName: 'FinishIcon',
  },
  {
    value: ETabs.REVIEW,
    title: t('reports.tabs.review'),
    iconName: 'SlideIcon',
  },
  {
    value: ETabs.CLIENTS,
    title: t('reports.tabs.clients'),
    iconName: 'AlienIcon',
  },
  {
    value: ETabs.VISITORS,
    title: t('reports.tabs.visits'),
    iconName: 'PosetiteliIcon',
  },
  {
    value: ETabs.HOSTS_OCCUPATION,
    title: t('reports.tabs.hosts'),
    iconName: 'ComputerIcon',
  },
  {
    value: ETabs.PLAY_AND_APLLICATIONS,
    title: t('reports.tabs.applicationReport'),
    iconName: 'PacmanIcon',
  },
  {
    value: ETabs.SALES,
    title: t('reports.tabs.sales'),
    iconName: 'ShopIcon',
  },
  {
    value: ETabs.TRANSFERS,
    title: t('reports.tabs.transfers'),
    iconName: 'LeftRightArrowsIcon',
    disabled: !permissions?.has('deposit_transfer'),
  },
  {
    value: ETabs.BONUS,
    title: t('money.bonus'),
    iconName: 'BonusIcon',
    disabled: !permissions?.has('reports_manage'),
  },
];

export { getTabs };
